import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Bazele SQL Server citite de agentul de Windows (`it_sql_databases`):
 * pe fisa aparatului si pe componenta Database a unei aplicatii.
 */

export type SqlDatabase = {
  name: string
  state: string
  recovery: string
  /** null = marimea nu se poate citi (lipseste VIEW ANY DEFINITION). */
  sizeMb: number | null
  /** `Y-m-d H:i:s`, ora serverului SQL; null = niciunul sau necitit. */
  lastFullBackup: string | null
  system: boolean
  collectedAt: string
}

export type SqlInstance = {
  engine: string
  name: string
  status: 'ok' | 'partial' | 'no_access' | 'stopped' | 'error' | string
  statusLabel: string
  version: string
  edition: string
  error: string
  databases: SqlDatabase[]
}

export type DeviceSqlDatabasesPage = {
  ready: boolean
  collectedAt: string | null
  instances: SqlInstance[]
}

export type AppDatabase = SqlDatabase & {
  deviceId: number
  deviceName: string
  instance: string
  /** "database CHARISMA_PROD, 42 GB, last full backup 2026-10-04" */
  label: string
}

export type AppDatabasesPage = {
  patterns: string[]
  databases: AppDatabase[]
}

export function deviceSqlDatabasesQuery(deviceId: number) {
  return queryOptions({
    queryKey: ['sql-databases', 'device', deviceId],
    queryFn: () => apiGet<DeviceSqlDatabasesPage>(`/devices/${deviceId}/sql-databases`),
    enabled: deviceId > 0,
  })
}

export function appDatabasesQuery(appId: number) {
  return queryOptions({
    queryKey: ['sql-databases', 'app', appId],
    queryFn: () => apiGet<AppDatabasesPage>(`/business-apps/${appId}/databases`),
    enabled: appId > 0,
  })
}

/** 900 MB, 1.5 GB, 120 GB - la fel ca `SqlDatabases::size` din api. */
export function formatSizeMb(mb: number): string {
  if (mb < 1024) return `${mb} MB`
  const gb = mb / 1024
  return `${gb >= 100 ? Math.round(gb) : Number(gb.toFixed(1))} GB`
}
